// Rwanda destination — packages DERIVED from the single source
// (data/rwandaTourData.js → rwandaPackages).
import { rwandaPackages } from '../rwandaTourData';
import { canonicalPackage } from './adapt';

const packages = rwandaPackages.map((p) =>
  canonicalPackage({
    id: p.tour_code,
    name: p.name,
    countryName: 'Rwanda',
    duration: p.duration, // { nights, days }
    priceFrom: null, // raw Rwanda packages carry no rates yet
    description: p.description || '',
    highlights: p.highlights || (p.highlight ? [p.highlight] : []),
    regions: p.destinations || [],
    coverImage: p.coverImage,
    itinerary: p.itinerary,
  })
);

export const rwandaDestination = {
  key: 'rwanda',
  name: 'Rwanda',
  emoji: '🇷🇼',
  tagline: 'Mountain gorillas, lush landscapes, and unique wildlife encounters',
  signature: 'Mountain Gorilla Trekking',
  heroImage:
    'https://images.unsplash.com/photo-1667504319000-8133f9021cf8?w=1920&h=1080&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzR8fHJ3YW5kYXxlbnwwfHwwfHx8MA%3D%3D',
  highlights: ['Mountain Gorillas', 'Volcanoes National Park', 'Lake Kivu', 'Nyungwe Forest'],
  bestTime: 'June-September (Dry season), December-February (Short dry season)',
  wildlife: ['Mountain Gorillas', 'Chimpanzees', 'Golden Monkeys', 'Primates'],
  climate: 'Temperate with two rainy seasons',
  currency: 'Rwandan Franc (RWF)',
  language: 'Kinyarwanda, English, French',
  mapCenter: [-1.9403, 29.8739],
  mapMarkers: [
    { position: [-1.4433, 29.5622], name: 'Volcanoes National Park' },
    { position: [-2.4878, 29.1855], name: 'Nyungwe Forest' },
    { position: [-1.5833, 30.7667], name: 'Akagera' },
    { position: [-2.0, 29.25], name: 'Lake Kivu' },
  ],
  packages,
};
